module.exports = __webpack_public_path__ + "img/origin_0226025355.3ac35f97.png";